export default ["768px", "1120px", "1400px"]
